export default "__VITE_ASSET__bYKAOC6G__"